import React from "react";

import { Badge } from "antd";

import { rawPalette } from "../../styles/theme.css";

import * as theme from "./MenuBadge.css";

interface MenuBadgeProps {
    children: React.ReactNode;
    count: number;
    hasOverdueActions: boolean;
}
interface BadgeProps {
    offset: [number, number];
    size: string;
}

export function MenuBadge({
    children,
    count,
    hasOverdueActions,
}: MenuBadgeProps) {
    const getBadgeSizeAndOffset = (count: number): BadgeProps => {
        if (count > 99) {
            return { size: theme.large, offset: [18, 0] };
        }
        if (count > 9) {
            return { size: theme.medium, offset: [15, 0] };
        }
        return { size: theme.small, offset: [15, 0] };
    };

    const { offset, size } = getBadgeSizeAndOffset(count);

    return (
        <Badge
            offset={offset}
            className={`${theme.badge} ${size}`}
            style={{
                backgroundColor: hasOverdueActions
                    ? "#E53F3F"
                    : rawPalette.base.brandEmerald[500],
            }}
            count={count}
        >
            {children}
        </Badge>
    );
}
